export const COMPARISON_CONSTANTS = {
  title: "Network Transformation: Traditional vs OneMind",
  desc: "OneMind empowers enterprises with secure, software-defined networking that adapts to changing workloads, while legacy networks struggle with rigidity, visibility gaps, and costly manual management.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional Networking",
      points: [
        "Hardware-centric networks with limited flexibility",
        "Manual configuration across distributed locations",
        "No centralized visibility or real-time monitoring",
        "Performance issues during traffic surges",
        "Vendor-locked architectures with long upgrade cycles",
        "Limited support for remote users and edge devices",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Intelligent Networking",
      points: [
        "Software-defined control with dynamic routing and policy enforcement",
        "Cloud-managed provisioning for fast, scalable deployment",
        "Real-time insights into traffic, apps, and endpoints",
        "Optimized performance with intelligent path selection",
        "Vendor-neutral infrastructure that evolves with your needs",
        "Seamless support for hybrid work, branch offices, and IoT",
      ],
    },
  ],
};
